import { isIntrisingEmail, isLantechQAEmail, canSeeMtMenu, canEditPtReleaseNote } from '../utils/permissions'

export default {
  computed: {
    isIntrising () {
      return isIntrisingEmail(this.user && this.user.email)
    },
    isLantechQA () {
      return isLantechQAEmail(this.user && this.user.email)
    },
    canSeeMtMenu () {
      return canSeeMtMenu(this.user || {})
    },
    canEditPtReleaseNote () {
      return canEditPtReleaseNote(this.user || {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissionsMixin.js